import script from "./ContactoMobile.vue?vue&type=script&lang=js"
export * from "./ContactoMobile.vue?vue&type=script&lang=js"

import "./ContactoMobile.vue?vue&type=style&index=0&id=a8896728&lang=css"

const __exports__ = script;

export default __exports__